import { createFileRoute } from "@tanstack/react-router";
import { SitesPage } from "@/components/sites/list";

export const Route = createFileRoute(
  "/dashboard/_admin/company/$companyId/sites/",
)({
  component: SitesPage,
  staticData: {
    title: "Assets",
    parent: { title: "Company Management", path: "/dashboard/company" },
  },
});
